var _ellipse, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletIconParkOutlineRectangularCircularConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 37.8975,
    rx: 22.5,
    ry: 7.5,
    fill: "#D5EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22.668C21.344 22.668 22.3932 22.2597 23.1668 21.533C23.9404 20.8063 24.375 19.8207 24.375 18.793C24.375 17.7653 23.9404 16.7796 23.1668 16.0529C22.3932 15.3262 21.344 14.918 20.25 14.918C19.156 14.918 18.1068 15.3262 17.3332 16.0529C16.5596 16.7796 16.125 17.7653 16.125 18.793C16.125 19.8207 16.5596 20.8063 17.3332 21.533C18.1068 22.2597 19.156 22.668 20.25 22.668ZM23.6875 30.418H16.8125V36.8763H23.6875V30.418Z",
    fill: "white",
    stroke: "#D5EEFF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.655 18.793H40.875V33.6471H29.1875",
    stroke: "#D5EEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22.668C21.344 22.668 22.3932 22.2597 23.1668 21.533C23.9404 20.8063 24.375 19.8207 24.375 18.793C24.375 17.7653 23.9404 16.7796 23.1668 16.0529C22.3932 15.3262 21.344 14.918 20.25 14.918C19.156 14.918 18.1068 15.3262 17.3332 16.0529C16.5596 16.7796 16.125 17.7653 16.125 18.793C16.125 19.8207 16.5596 20.8063 17.3332 21.533C18.1068 22.2597 19.156 22.668 20.25 22.668ZM23.6875 30.418H16.8125V36.8763H23.6875V30.418Z",
    fill: "white",
    stroke: "#0593F5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.655 18.793H40.875V33.6471H29.1875",
    stroke: "#0593F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIconParkOutlineRectangularCircularConnection);
export default __webpack_public_path__ + "static/media/tablet-icon-park-outline_rectangular-circular-connection.f2cf8196d884a065ee2623d8bcf0669e.svg";
export { ForwardRef as ReactComponent };